import React from 'react';

import type { ComponentProps } from 'react';
import UpRatingLabel from 'App/babel/components/LegacyReactTemplates/upRatingLabel';

type Props = ComponentProps<typeof UpRatingLabel>;
const RatingLabel = (props: Props) => <UpRatingLabel {...props} />;

export default RatingLabel;
